/**
 * Created by Andrey Popov on 15.10.20
 */

const AdminLevelFlagsPanel = cleverapps.Layout.AsyncChild.extend({
    ctor: function (adminLevel, maxi) {
        this._super();

        this.adminLevel = adminLevel;
        this.maxi = maxi;

        if (!maxi) {
            this.setScale(0.8);
        }

        this.updateFlags();

        adminLevel.on("update", this.updateFlags.bind(this), this);
        if (AdminConfig.getConfig("difficulty")) {
            adminLevel.on("changeDifficulty", this.updateFlags.bind(this), this);
        }
    },

    updateFlags: function () {
        this.removeAllChildren();

        if (this.adminLevel.dragging) {
            return;
        }

        const events = this.listBoosters().concat(cleverapps.administrator.simpleMethaDataProvider.getEvents(parseInt(this.adminLevel.episodeNo), this.adminLevel.levelNo));

        const flags = events.filter((event) => event.icon).map((event) => {
            const yellowBanner = new cc.Sprite(bundles.admin.frames.yellow_flag);

            const icon = new cc.Sprite(event.icon);
            icon.setAlignment(yellowBanner.width / 2, yellowBanner.height / 2);
            yellowBanner.addChild(icon);

            cleverapps.UI.fitToBox(icon, {
                width: yellowBanner.width * 0.8,
                height: yellowBanner.height * 0.8
            });

            if (event.tooltip) {
                cleverapps.tooltipManager.create(yellowBanner, {
                    text: event.tooltip,
                    position: cleverapps.UI.Tooltip.LOCATION_BELOW,
                    size: cleverapps.styles.UI.Tooltip.SIZE.short
                });
            }

            return yellowBanner;
        });

        const config = AdminConfig.getConfig("difficulty");
        if (config && (this.adminLevel.difficulty < config.bottom || this.adminLevel.difficulty > config.top)) {
            flags.unshift(new cc.Sprite(bundles.admin.frames.attention_icon));
        }

        const styles = cleverapps.styles.AdminLevelFlagsPanel;

        const layout = new cleverapps.Layout(flags, {
            direction: this.maxi ? cleverapps.UI.HORIZONTAL : cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        this.reshape(layout);
    },

    listBoosters: function () {
        const allBoosters = cleverapps.boosters.listAll();
        return allBoosters.filter((booster) => this.isDiscoveredHere(booster.available)).map(function (booster) {
            return { ...cleverapps.Boosters.CONFIG[booster.id], icon: this.getBoosterIcon(booster.id) };
        }, this);
    },

    isDiscoveredHere: function (available) {
        if (available.actualLevel) {
            return available.actualLevel === cleverapps.humanReadableNumber(this.adminLevel.episodeNo, this.adminLevel.levelNo);
        }

        return parseInt(this.adminLevel.episodeNo) === (available.episode || 0) && this.adminLevel.levelNo === (available.level || 0);
    },

    getBoosterIcon: function (booster) {
        const icons = {};
        icons[cleverapps.Boosters.TYPE_CELL] = bundles.reward_icons.frames.cellbooster;
        icons[cleverapps.Boosters.TYPE_LINE] = bundles.reward_icons.frames.linebooster;
        icons[cleverapps.Boosters.TYPE_COLOR] = bundles.reward_icons.frames.colorbooster;
        icons[cleverapps.Boosters.TYPE_HINT] = bundles.reward_icons.frames.hint_icon_png;
        icons[cleverapps.Boosters.TYPE_WILDCARD] = bundles.admin.frames.wildcard_png;
        icons[cleverapps.Boosters.TYPE_SHUFFLE] = bundles.admin.frames.shuffle_png;
        icons[cleverapps.Boosters.TYPE_BRUSH] = bundles.reward_icons.frames.pot;
        icons[cleverapps.Boosters.TYPE_DISCOVER] = bundles.reward_icons.frames.hat;
        if (typeof match3 !== "undefined") {
            icons[cleverapps.Boosters.TYPE_COMBO] = bundles.reward_icons.frames.heroes_png;
        }
        icons[cleverapps.Boosters.TYPE_MOVES] = bundles.reward_icons.frames.moves_png;
        icons[cleverapps.Boosters.TYPE_MULTICOLOR] = bundles.reward_icons.frames.multicolor_png;
        icons[cleverapps.Boosters.TYPE_MAGNET] = bundles.reward_icons.frames.magnet_png;
        icons[cleverapps.Boosters.TYPE_DICE] = bundles.reward_icons.frames.dice_png;
        icons[cleverapps.Boosters.TYPE_JOKERS] = bundles.reward_icons.frames.joker_png;
        icons[cleverapps.Boosters.TYPE_HIGHLIGHT] = bundles.reward_icons.frames.highlight;
        icons[cleverapps.Boosters.TYPE_EYE] = bundles.reward_icons.frames.eye;
        icons[cleverapps.Boosters.TYPE_MAGNIFIER] = bundles.reward_icons.frames.hint;
        return icons[booster];
    }
});

cleverapps.styles.AdminLevelFlagsPanel = {
    margin: 10
};